export const TAGS = {
  LOYALTY_STATUS: "LoyaltyStatus",
  LOYALTY_POINTS: "LoyaltyPoints",
  LOYALTY_TIERS: "LoyaltyTiers",
  LOYALTY_VOUCHERS: "LoyaltyVouchers",
  LOYALTY_REFERRAL: "LoyaltyReferral",
} as const;
